export default __webpack_public_path__ + "static/modal03_01-88f52e18a42f50248f1949ff27bd66db.jpg";